import React from 'react';
import {Button} from "semantic-ui-react";

const GridHeader = ({name, width, input, loading, downloadExcel, canCreate, history, btn}) => {
    return (
        <section className={`header-block`} style={{width: width && width + 'px'}}>
            <div className='name-block'>
                <h1>
                    {name}
                </h1>
                {input && input}
            </div>

            <div className="buttons-block">
                {downloadExcel && <Button
                    className='btn_border_blue'
                    onClick={() => downloadExcel()}
                    disabled={loading}
                >
                    Выгрузка в Excel
                </Button>}
                {history && canCreate && <Button
                    className='btn_light-blue btn_icon_plus'
                    onClick={() => history.push('/parcels/new')}
                >
                    Создать отправление
                </Button>}
                {btn && btn}
            </div>
        </section>
    );
};

export default GridHeader;


// WEBPACK FOOTER //
// ./App/components/GridHeader.jsx